export default {
  announcementApi: {
    getPublishList: 'api/announcementPublished/getPublishList',
    getList: 'api/announcement/getList',
    delAnnouncements: 'api/announcement/delAnnouncements',
    getDetail: 'api/announcement/getDetail',
    saveOrUpdateAnnouncement: 'api/announcement/saveOrUpdateAnnouncement',
    revokeAnnouncement: 'api/announcement/revokeAnnouncement',
    restoreAnnouncement: 'api/announcement/restoreAnnouncement',
    getUserViewList: 'api/announcement/getUserViewList',
  }
}